import { Component, Input } from '@angular/core';

@Component({
  selector: 'apc-admin-extras-form',
  templateUrl: './extras-form.component.html',
  styleUrls: ['./extras-form.component.scss']
})
export class ExtrasFormComponent {
  @Input() public form: any;
  @Input() public type: string;
  @Input() readDisable = true;


  public mode = [
    {
      value: 'NONE',
      name: 'NONE',
    },
    {
      value: 'USER_ONE',
      name: 'USER_ONE',
    },
    {
      value: 'USER_ONE_AT_A_TIME',
      name: 'USER_ONE_AT_A_TIME',
    },
    {
      value: 'GLOBAL_ONE',
      name: 'GLOBAL_ONE',
    },
    {
      value: 'GLOBAL_ONE_AT_A_TIME',
      name: 'GLOBAL_ONE_AT_A_TIME',
    },
  ];
  public customFields = [
    {
      value: 'STRING',
      name: 'STRING',
    },
    {
      value: 'INT',
      name: 'INT',
    },
    {
      value: 'FLOAT',
      name: 'FLOAT',
    },
    {
      value: 'BOOLEAN',
      name: 'BOOLEAN',
    },
    {
      value: 'DATE',
      name: 'DATE',
    },
  ];
}
